import React from 'react'
import "../css/Intro.css"


function Intro() {
  return (
    <div className="intro">
        <div className="i-left">
            <div className="i-name">
              
                <span>Hi, I am</span>
                <span>Devanshu Dalal</span>
                <span>Junior CSE, VIT Pune</span>
            </div>
            <button className="button i-button">Hire me</button>
        </div>
        <div className="i-right">
        </div>
    </div>
  )
}

export default Intro